import { extendTheme } from "@chakra-ui/react";

import { fonts } from "./fonts";
import { colours } from "./colours";

import { alertTheme } from "./components/alert";
import { buttonTheme } from "./components/button";
import { checkboxTheme } from "./components/checkbox";
import { inputTheme } from "./components/input";
import { linkTheme } from "./components/link";
import { menuTheme } from "./components/menu";
import { modalTheme } from "./components/modal";
import { spinnerTheme } from "./components/spinner";
import { tableTheme } from "./components/table";
import { tabsTheme } from "./components/tabs";
import { tagTheme } from "./components/tag";
import { textAreaTheme } from "./components/textArea";
import { tooltipTheme } from "./components/tooltip";
import { switchTheme } from "./components/switch";

const overrides = {
	fonts: fonts,
	colors: colours,
	styles: {
		global: {
			// Chakra's toast manager reads this variable, not zIndices.toast. Must sit above the
			// Rules Library drawer's PortalManager (100002) in RegularClassroom.
			":root": {
				"--toast-z-index": "100003",
			},
		},
	},
	components: {
		Alert: alertTheme,
		Button: buttonTheme,
		Checkbox: checkboxTheme,
		Input: inputTheme,
		Link: linkTheme,
		Menu: menuTheme,
		Modal: modalTheme,
		Spinner: spinnerTheme,
		Table: tableTheme,
		Tabs: tabsTheme,
		Tag: tagTheme,
		Textarea: textAreaTheme,
		Tooltip: tooltipTheme,
		Switch: switchTheme,
	},
};

// https://v2.chakra-ui.com/docs/styled-system/customize-theme#using-theme-extensions
export const theme = extendTheme(overrides);
